import { z } from 'zod';

export const CustomerServiceTeamSchema = z.object({
  id: z.number(),
  name: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});
